.rate-card {
  display: flex;
  flex-flow: column nowrap;
  align-items: stretch;
  justify-content: center;

  background: var(--default--background-color-18);
  border-color: var(--default--border-color--15);
}
